import { Icon } from '@iconify/react';
import closeCircleFill from '@iconify/icons-eva/close-circle-fill';
import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------
// V2 Modern Chip Styling

export default function Chip(theme) {
  const primaryMain = '#7635dc';

  return {
    MuiChip: {
      defaultProps: {
        deleteIcon: <Icon icon={closeCircleFill} />
      },

      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          fontWeight: 600,
          transition: 'all 0.2s ease-in-out'
        },
        colorDefault: {
          backgroundColor: alpha(primaryMain, 0.08),
          color: primaryMain,
          '&:hover': {
            backgroundColor: alpha(primaryMain, 0.15)
          },
          '& .MuiChip-avatarMedium, .MuiChip-avatarSmall': {
            color: theme.palette.text.secondary
          }
        },
        colorPrimary: {
          backgroundColor: alpha(primaryMain, 0.1),
          color: primaryMain,
          '&:hover': {
            backgroundColor: alpha(primaryMain, 0.2)
          }
        },
        filledPrimary: {
          backgroundColor: primaryMain,
          color: '#fff',
          '&:hover': {
            backgroundColor: alpha(primaryMain, 0.85)
          }
        },
        outlined: {
          borderColor: theme.palette.grey[500_32],
          '&.MuiChip-colorPrimary': {
            borderColor: primaryMain,
            color: primaryMain,
            '&:hover': {
              backgroundColor: alpha(primaryMain, 0.08)
            }
          },
          '&.MuiChip-colorSecondary': {
            borderColor: theme.palette.secondary.main
          }
        },
        avatarColorInfo: {
          color: theme.palette.info.contrastText,
          backgroundColor: theme.palette.info.dark
        },
        avatarColorSuccess: {
          color: theme.palette.success.contrastText,
          backgroundColor: theme.palette.success.dark
        },
        avatarColorWarning: {
          color: theme.palette.warning.contrastText,
          backgroundColor: theme.palette.warning.dark
        },
        avatarColorError: {
          color: theme.palette.error.contrastText,
          backgroundColor: theme.palette.error.dark
        }
      }
    }
  };
}
